import React, { Suspense } from 'react';

import styled from 'styled-components';

// components
import LoadingSpinner from '../loading/nestedSpinner';

const LazyWithSuspense = (
    WrappedComponent: React.ComponentType<React.PropsWithChildren<unknown>>,
) =>
    class extends React.Component {
        render() {
            return (
                <Suspense
                    fallback={
                        <Container>
                            <LoadingSpinner />
                        </Container>
                    }
                >
                    <WrappedComponent {...this.props} />
                </Suspense>
            );
        }
    };

export default LazyWithSuspense;

const Container = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100wh',
    minHeight: '100vh',
});
